import styled from "styled-components";

export const Container = styled.div`

  .header{
    padding: 16px;
    border-bottom: 1px solid #96989A;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3{
      font-size: 16px;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }

    button{
      border: none;
      background-color: transparent;
      height: 22px;
      cursor: pointer;
    }
  }
`;

export const Body = styled.div`
  padding: 16px 32px;

  .action_container{
    display: flex;
    justify-content: space-between;

    div{
      display: flex;
      gap: 16px;

      button {
        padding: 8px 16px;
        border-radius: 5px;
        border: 1px solid #000;
        font-size: 14px;
        font-weight: 500;
        background-color: #fff;
        cursor: pointer;
        font-style: normal;
        line-height: normal;
      }
    }

  }

  .infos_data {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;

    p {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      color: #282828;
      margin: 0;
    }
  }

`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  button{
    cursor: pointer;
    background-color: var(--color-primary);
    color: #fff;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 5px;
    border: none;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;

  div{
    display: flex;
    gap: 16px;

    button {
      padding: 8px 16px;
      border-radius: 5px;
      font-weight: 600;

      cursor: pointer;
      font-size: 12.8px;
      font-style: normal;
      line-height: normal;
    }

    .go_back {
      background-color: #fff;
      color: #000;
      border: 1px solid #000;
    }
  }

  .upload_btn{
    cursor: pointer;
    background-color: var(--color-primary);
    color: #fff;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 5px;
    border: none;

    input{
      display: none;
    }
  }
`;

export const ButtonInvitation = styled.button`
  background-color: ${({ active }) => active ? 'var(--color-primary)' : '#96989A'};
  color: #fff;
  border: 1px solid ${({ active }) => active ? 'var(--color-primary)' : '#96989A'};
`;

export const InputInvitation = styled.input`
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #282828;
  min-width: 280px;

  &:disabled{
    background-color: #96989A;
    border: 1px solid #96989A;
  }
`;
